<template>
  <section class="page">
    <div class="page__header">
      <div class="page__title">
        <SharedBreadcrumbs :breadcrumbs />

        <FaqSearch />
      </div>

      <h1 class="typography__headline1">Список сотрудников и&nbsp;их данные</h1>
    </div>

    <div class="page__content">
      <FaqArticlesAside :menu />

      <FaqArticlesContent>
        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="spisok-sotrudnikov"
            class="typography__headline2"
          >
            Список сотрудников
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>В&nbsp;меню слева перейдите в&nbsp;раздел &laquo;Сотрудники&raquo;.</p>

            <p>Сверху справа можно добавить нового сотрудника, нажав соответствующую кнопку.</p>

            <p>
              В&nbsp;списке есть важная информация о&nbsp;сотруднике, возможность быстро скрыть его с&nbsp;сайта или
              перейти к&nbsp;редактированию или удалению.
            </p>

            <p>По&nbsp;нажатию на&nbsp;имя сотрудника перейдем к&nbsp;его странице.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/spisok-sotrudnikov-i-ikh-dannye-1.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>Над списком есть сортировка, фильтры и&nbsp;поисковая строка для быстрого поиска нужного сотрудника.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/spisok-sotrudnikov-i-ikh-dannye-2.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="stranica-sotrudnika"
            class="typography__headline2"
          >
            Страница сотрудника
          </FaqArticlesBlockHeading>

          <p>
            На&nbsp;открывшейся странице сотрудника можно увидеть всю нужную информацию, перейти к&nbsp;редактированию
            или удалить его.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/spisok-sotrudnikov-i-ikh-dannye-3.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            В&nbsp;блоке ниже можно посмотреть все услуги, оказываемые этим сотрудником, и&nbsp;перейти к&nbsp;странице
            услуги по&nbsp;нажатию на&nbsp;неё.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/spisok-sotrudnikov-i-ikh-dannye-4.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>Блок с&nbsp;расписанием дает информацию о&nbsp;рабочем времени, днях и&nbsp;филиалах этого сотрудника.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/spisok-sotrudnikov-i-ikh-dannye-5.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            С&nbsp;добавлением сотрудника и&nbsp;просмотром его страницы разобрались. Самое время перейти
            к&nbsp;изучению и&nbsp;настройке
            <BaseLink
              class="ui-link-secondary"
              to="/faq/articles/raspisanie-raboty"
              >расписания работы сотрудников всего проекта</BaseLink
            >.
          </p>
        </div>
      </FaqArticlesContent>
    </div>

    <div class="page__related">
      <h2
        class="typography__headline2"
        v-html="t('pages.faq.otherArticles')"
      />

      <FaqArticlesList :articles="relatedArticles" />
    </div>
  </section>

  <LazyFaqArticlesImageModal
    v-if="isModalOpen(MODAL.FaqArticlesImage) && activeImageSource"
    :src="activeImageSource"
    @close="() => (activeImageSource = null)"
  />
</template>

<script lang="ts" setup>
const { t } = useI18n();
const { isModalOpen } = useModalStore();
const activeImageSource = ref<null | string>(null);

const breadcrumbs = [
  {
    name: t("pages.faq.title"),
    url: "/faq",
  },
  {
    name: "Сотрудники",
    url: "/faq/categories/sotrudniki",
  },
  {
    name: "Список сотрудников и&nbsp;их данные",
  },
];

const menu = [
  {
    name: "Список&nbsp;сотрудников",
    url: "spisok-sotrudnikov",
  },
  {
    name: "Страница&nbsp;сотрудника",
    url: "stranica-sotrudnika",
  },
];

const relatedArticles = [
  {
    name: "Добавление и&nbsp;редактирование сотрудника",
    slug: "dobavleniye-i-redaktirovaniye-sotrudnika",
  },
  {
    name: "Расписание сотрудника",
    slug: "raspisaniye-raboty",
  },
  {
    name: "Уведомления сотрудника",
    slug: "uvedomleniya-sotrudnika",
  },
];

useSeoMeta({
  title: "Список сотрудников и их данные",
});
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__header {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__title {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.page__content {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

@media (--xl) {
  .page__content {
    flex-direction: row-reverse;
    justify-content: start;
    align-items: start;
  }
}

.page__related {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}
</style>
